<header
  class="header flex-center-middle"
  [ngClass]="{
    homeHeader: router.url == '/home',
    grantsHeader: checkIfGrantDetailsPage(),
    headerPage:
      router.url == '/state-health' ||
      router.url == '/county-health' ||
      router.url == '/about'
  }"
>
  <div
    class="logo-container flex-center-middle pointer-mouse"
    (click)="goHome()"
    (keydown)="goHome()"
  >
    <a class="textdec-none pointer-mouse flex-value-0">
      <img
        class="logo-icon pull-left pb-2"
        src="assets/icons/svg/HeartLogo.svg"
        alt="Webiste logo"
    /></a>
    <h1 class="logo pointer-mouse">
      <a class="HeaderClass"> EY Impact</a>
    </h1>
  </div>
  <div class="status-bar">
    <ul class="main-nav flex-center-middle" *ngIf="!hideHeaderItems">
      <li
        class="wgt-150px"
        id="explore_data"
        [matMenuTriggerFor]="dropdown"
        #menuTriggerData="matMenuTrigger"
        *ngIf="haService?.healthSetData?.length > 0"
      >
        <a
          class="nav-menu-items labels d-flex item"
          [ngClass]="{
            'bg-white': menuTriggerData.menuOpen
          }"
        >
          <span class="alignText label-color labels pddg-btm-2px"
            >Explore Data</span
          >
          <span
            class="dropdown-icon"
            [ngClass]="{
              'dropdown-icon-rotate': menuTriggerData.menuOpen
            }"
          ></span>
        </a>
        <mat-menu #dropdown="matMenu">
          <div
            class="dropdown-container explore-menu-item"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <ng-scrollbar
              appearance="compact"
              [autoHeightDisabled]="true"
              [autoWidthDisabled]="true"
              class="scroll-container wgt-170px hgt-75px"
            >
              <button
                mat-menu-item
                class="drp-height pt-2 pb-1"
                *ngFor="let data of haService.healthSetData"
                (click)="
                  menuTriggerData.closeMenu(); clearStore(data.datasetId)
                "
              >
                <span class="hor-scroll">
                  {{ data.name }}
                </span>
              </button>
            </ng-scrollbar>
          </div>
        </mat-menu>
      </li>

      <li
        class="wgt-100px"
        id="grants"
        [matMenuTriggerFor]="dropdownGrant"
        #menuTriggerGrant="matMenuTrigger"
      >
        <a
          class="nav-menu-items labels d-flex item"
          [ngClass]="{
            'bg-white': menuTriggerGrant.menuOpen
          }"
        >
          <span class="alignText label-color labels pddg-btm-2px">Grants</span>
          <span
            class="dropdown-icon"
            [ngClass]="{
              'dropdown-icon-rotate': menuTriggerGrant.menuOpen
            }"
          ></span>
        </a>
        <mat-menu #dropdownGrant="matMenu" class="grant-menu-item">
          <div
            class="dropdown-container"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <ng-scrollbar
              appearance="compact"
              [autoHeightDisabled]="true"
              [autoWidthDisabled]="true"
              class="scroll-container wgt-180px hgt-4rem"
            >
              <button
                mat-menu-item
                class="drp-height pt-2 pb-1"
                routerLink="/grants-dashboard"
                (click)="menuTriggerGrant.closeMenu()"
              >
                <span class="hor-scroll"> Find Grants </span>
              </button>
              <button
                mat-menu-item
                class="drp-height pt-2"
                routerLink="/executive-dashboard"
                (click)="menuTriggerGrant.closeMenu()"
              >
                <span class="hor-scroll"> Grants Dashboard </span>
              </button>
            </ng-scrollbar>
          </div>
        </mat-menu>
      </li>

      <li
        class="wgt-130px"
        id="impact"
        [matMenuTriggerFor]="dropdownKnowledge"
        #menuTriggerKnowledge="matMenuTrigger"
      >
        <a
          class="nav-menu-items labels d-flex item"
          [ngClass]="{
            'bg-white': menuTriggerKnowledge.menuOpen
          }"
        >
          <span class="alignText label-color labels pddg-btm-2px"
            >Impact.AI</span
          >
          <span
            class="dropdown-icon"
            [ngClass]="{
              'dropdown-icon-rotate': menuTriggerKnowledge.menuOpen
            }"
          ></span>
        </a>
        <mat-menu #dropdownKnowledge="matMenu">
          <div
            class="dropdown-container"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <ng-scrollbar
              appearance="compact"
              [autoHeightDisabled]="true"
              [autoWidthDisabled]="true"
              class="scroll-container wgt-170px hgt-4rem"
            >
              <button
                mat-menu-item
                class="drp-height pt-2 pb-1"
                (click)="openDocumentCanvas(); menuTriggerKnowledge.closeMenu()"
              >
                <span class="hor-scroll">Knowledge Chat</span>
              </button>
              <button
                mat-menu-item
                class="drp-height pt-2"
                (click)="goToDataCatalog(); menuTriggerKnowledge.closeMenu()"
              >
                <span class="hor-scroll">Knowledge Hub </span>
              </button>
            </ng-scrollbar>
          </div>
        </mat-menu>
      </li>

      <li
        class="drpdwn-menu drpdwn-width"
        [matMenuTriggerFor]="dropdown"
        #menuTrigger="matMenuTrigger"
        *ngIf="auth.hasLoggedIn"
      >
        <a
          class="nav-menu-items labels d-flex item"
          [ngClass]="{
            'bg-white': menuTrigger.menuOpen
          }"
        >
          <span class="alignText label-color labels pddg-btm-2px"
            >Saved Searches</span
          >
          <span
            class="dropdown-icon"
            [ngClass]="{
              'dropdown-icon-rotate': menuTrigger.menuOpen
            }"
          ></span>
        </a>
        <mat-menu #dropdown="matMenu">
          <div
            class="dropdown-container"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <ng-scrollbar
              appearance="compact"
              [autoHeightDisabled]="true"
              [autoWidthDisabled]="true"
              class="scroll-container hgt-13-5rem"
            >
              <ng-container>
                <div
                  mat-menu-item
                  class="drp-height pt-1 settings-item"
                  (click)="goToSettings('searches'); menuTrigger.closeMenu()"
                  (keydown)="goToSettings('searches'); menuTrigger.closeMenu()"
                >
                  Manage Saved Searches
                </div>
              </ng-container>

              <ng-container *ngIf="haService.savedSearchData?.length > 0">
                <ng-container *ngFor="let data of haService.savedSearchData">
                  <button
                    mat-menu-item
                    class="drp-height pt-1"
                    (click)="menuTrigger.closeMenu(); openCountyExplore(data)"
                  >
                    <span
                      class="hor-scroll"
                      matTooltip="{{ data.settingsName }}"
                      matTooltipPosition="left"
                      [matTooltipClass]="'header-saved-search-item'"
                    >
                      {{ data.settingsName }}</span
                    >
                  </button>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!savedSearchdata?.length">
                <button
                  mat-menu-item
                  class="drp-height pt-1 d-flex align-center justify-content-center"
                >
                  <i class="ft-13">No Saved Searches</i>
                </button>
              </ng-container>
            </ng-scrollbar>
          </div>
        </mat-menu>
      </li>

      <li *ngIf="!auth.hasLoggedIn">
        <a
          class="nav-menu-items login item labels"
          [ngClass]="auth.showLoginModal ? 'active' : ''"
          (click)="toggleLogin()"
          >Login</a
        >
      </li>
    </ul>
    <div
      class="header-icon ps-3"
      *ngIf="auth.hasLoggedIn"
      id="notification_icon"
    >
      <div
        class="float-action"
        id="chatbot_icon"
        [ngClass]="{
          'move-lower': haService.chatBotDialogOpened
        }"
        (click)="haService.openChatBotPopUp($event)"
        (keydown)="$event.stopPropagation()"
      ></div>

      <ng-container *ngIf="!showNotification; else newNotification">
        <img
          src="../../../assets/icons/svg/notification.svg"
          alt="notification"
          (click)="openNotificationPopup(); showNotification = false"
          class="cursor-pointer action-i"
          (keydown)="openNotificationPopup(); showNotification = false"
          height="21"
          width="21"
        />
      </ng-container>
      <ng-template #newNotification>
        <img
          src="../../../assets/icons/svg/active-notification.svg"
          alt="notification"
          (click)="openNotificationPopup(); showNotification = false"
          class="cursor-pointer action-i bell"
          (keydown)="openNotificationPopup(); showNotification = false"
          height="24"
          width="24"
        />
      </ng-template>
    </div>
    <div
      class="header-icon"
      id="user-icon"
      *ngIf="auth.hasLoggedIn"
      [matMenuTriggerFor]="dropdown"
      #menuTrigger="matMenuTrigger"
    >
      <img
        src="../../../assets/icons/svg/my-account.svg"
        alt="my-account"
        class="cursor-pointer action-i"
        height="24"
        width="24"
      />
      <mat-menu #dropdown="matMenu">
        <div
          class="dropdown-container"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <button
            *ngIf="auth.getTenants()?.length > 0"
            mat-menu-item
            class="organization-name border-bottom"
            (click)="updateOrganization(); menuTrigger.closeMenu()"
          >
            {{ getTenantName() }}
            <img
              class="edit-icon"
              src="../../../assets/icons/svg/edit.svg"
              alt="Edit"
              height="19"
              width="17"
            />
          </button>
          <button
            mat-menu-item
            class="drp-height pb-1 mb-1 pt-1"
            routerLink="/about"
            routerLinkActive="active"
            (click)="auth.showLoginModal = false; menuTrigger.closeMenu()"
          >
            About
          </button>

          <button
            mat-menu-item
            class="drp-height pb-1 pt-1 border-bottom"
            (click)="goToSettings('searches'); menuTrigger.closeMenu()"
          >
            My Activity Center
          </button>

          <button
            mat-menu-item
            class="drp-height pb-1 pt-1 border-bottom"
            (click)="startUserGuide(); menuTrigger.closeMenu()"
          >
            Start User Guide
          </button>

          <button
            mat-menu-item
            (click)="toggleLogin()"
            class="drp-height logout-text"
          >
            <span class="d-flex align-items-center justify-content-center">
              <span
                *ngIf="isLoggingOut"
                class="spinner-border spinner-border-sm spinner-border-logout"
              ></span
              >Log Out</span
            >
          </button>
        </div>
      </mat-menu>
    </div>
  </div>
</header>
